import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { Phone } from "lucide-react";
import { Logo } from "./Logo";
import { CONTACT } from "../data/site";
import { scrollToId, scrollToSequencePoint } from "../utils/scroll";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (v) => setScrolled(v > 80));

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ delay: 0.4, duration: 1, ease: [0.16, 1, 0.3, 1] }}
      data-testid="main-nav"
      className={`fixed inset-x-0 top-0 z-50 transition-[background-color,border-color,backdrop-filter] duration-700 ${
        scrolled
          ? "border-b border-white/10 bg-navy-950/70 backdrop-blur-xl"
          : "border-b border-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1600px] items-center justify-between px-6 py-4 md:px-10">
        <button
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.6 })}
          aria-label="Aspen Design — back to top"
          data-testid="nav-logo-button"
        >
          <Logo />
        </button>

        <nav className="hidden items-center gap-10 lg:flex" data-testid="nav-links">
          <button
            onClick={() => scrollToSequencePoint(0.55)}
            data-testid="nav-link-expertise"
            className="text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-slate-300 transition-colors duration-500 hover:text-gold"
          >
            Expertise
          </button>
          <button
            onClick={() => scrollToId("#portfolio")}
            data-testid="nav-link-portfolio"
            className="text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-slate-300 transition-colors duration-500 hover:text-gold"
          >
            Portfolio
          </button>
          <button
            onClick={() => scrollToId("#areas")}
            data-testid="nav-link-areas"
            className="text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-slate-300 transition-colors duration-500 hover:text-gold"
          >
            Areas
          </button>
          <button
            onClick={() => scrollToId("#contact")}
            data-testid="nav-link-contact"
            className="text-[0.65rem] font-semibold uppercase tracking-[0.3em] text-slate-300 transition-colors duration-500 hover:text-gold"
          >
            Contact
          </button>
        </nav>

        <div className="flex items-center gap-6">
          <a
            href={CONTACT.phoneHref}
            data-testid="nav-phone-link"
            className="hidden items-center gap-2 text-xs font-medium tracking-[0.15em] text-slate-200 transition-colors duration-500 hover:text-gold md:flex"
          >
            <Phone className="h-3.5 w-3.5 text-gold" strokeWidth={1.5} />
            {CONTACT.phone}
          </a>
          <button
            onClick={() => scrollToId("#contact")}
            data-testid="nav-cta-button"
            className="group relative overflow-hidden border border-gold/50 px-5 py-2.5"
          >
            <span className="relative z-10 text-[0.6rem] font-semibold uppercase tracking-[0.28em] text-white transition-colors duration-500 group-hover:text-navy-900">
              Consultation
            </span>
            <span className="absolute inset-0 origin-left scale-x-0 bg-gold transition-transform duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-x-100" />
          </button>
        </div>
      </div>
    </motion.header>
  );
}
